import 'core-js/stable';
import 'regenerator-runtime/runtime';

import React from 'react';
import { render } from 'react-dom';
import * as Sentry from '@sentry/react';

import App from 'App';

const MOUNT_NODE = document.getElementById('root');
const renderApp = () => render(<App />, MOUNT_NODE);

if (process.env.NODE_ENV !== 'development' && (process.env.SENTRY_DSN || process.env.SENTRY_DSN_USE_DEFAULT)) {
  Sentry.init({
    dsn: process.env.SENTRY_DSN || 'https://d677e1e4e8db46c697274d0e44f715a7@sentry-rnd.dev.femiglobal.com/3',
    release: process.env.RELEASE_VERSION,
    environment: process.env.NODE_ENV,
  });
}

renderApp();
